import { render, staticRenderFns } from "./RootHeaderBar.vue?vue&type=template&id=36e81e34&scoped=true"
import script from "./RootHeaderBar.vue?vue&type=script&lang=js"
export * from "./RootHeaderBar.vue?vue&type=script&lang=js"
import style0 from "./RootHeaderBar.vue?vue&type=style&index=0&id=36e81e34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e81e34",
  null
  
)

export default component.exports